import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {mainButton, standardButton} from '-/styles/mixins/button';
import {rem} from '-/styles/utils';

const styles = theme => {
    const standard = standardButton('white', theme.colors.secondary);

    const add = {
        ...standard,
        marginBottom: rem(10),
        width: 'auto'
    };

    return {
        main: mainButton('white', theme.colors.primary),
        alternate: mainButton('white', theme.colors.secondary),
        previous: mainButton(theme.colors.strong, 'transparent'),
        add,
        addRight: {
            ...add,
            float: 'right'
        },
        delete: {
            ...standard,
            backgroundColor: '#ff3333',
            float: 'right',
            width: 'auto'
        },
        disabled: {
            background: 'rgba(203, 165, 113, .5)',
            cursor: 'not-allowed'
        }
    };
};

class Button extends Component {
    static propTypes = {
        href: PropTypes.string,
        onClick: PropTypes.func,
        title: PropTypes.string,
        type: PropTypes.string,
        tag: PropTypes.string,
        className: PropTypes.string,
        role: PropTypes.string,
        width: PropTypes.any,
        btnStyle: PropTypes.string
    };

    static defaultProps = {
        btnStyle: 'main',
        tag: 'button',
        role: 'button',
        type: 'button'
    };

    render() {
        const {
            href,
            onClick,
            title,
            classes = {},
            btnStyle,
            type,
            children,
            tag,
            className,
            role,
            width,
            disabled
        } = this.props;

        const baseCls = classes[btnStyle];
        const buttonCls = classNames(baseCls, className, disabled ? classes['disabled'] : '');
        const props = {
            href,
            onClick,
            title,
            ...role && {role},
            type,
            disabled,
            className: buttonCls,
            ...width && {
                style: {
                    width: width === 'auto' ? 'auto' : `${width}%`
                }
            }
        };

        if (tag === 'a') {
            return <a {...props}>{children}</a>;
        } else {
            return <button {...props}>{children}</button>;
        }
    }
}

export default injectSheet(styles)(Button);
